import { TTS_STOP } from 'modules/ElementaryCareers/constants';
import {
  SET_TTS_DATA,
  SET_AUDIO_FILES,
} from 'modules/ElementaryCareers/store/actionTypes';

const STORAGE_KEY = 'read_aloud_state';

// Try to load initial state from localStorage
const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem(STORAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error('Error loading read aloud state from localStorage:', err);
    return undefined;
  }
};

// Save state to localStorage
const saveStateToLocalStorage = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STORAGE_KEY, serializedState);
  } catch (err) {
    console.error('Error saving read aloud state to localStorage:', err);
  }
};

const initialState = loadStateFromLocalStorage() || {
  ttsOption: TTS_STOP,
  playingItem: -1,
  ttsEnabledItems: [],
  audioFiles: {},
  isPlaying: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  let newState;
  switch (type) {
    case SET_TTS_DATA:
      newState = {
        ...state,
        ...payload,
      };
      break;
    case SET_AUDIO_FILES:
      newState = {
        ...state,
        audioFiles: { ...state.audioFiles, [payload.id]: payload.audio },
      };
      break;
    default:
      return state;
  }

  // Save the new state to localStorage
  saveStateToLocalStorage(newState);
  return newState;
};
